var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.page},[_c('navbar'),_c('div',{staticClass:"adm-wrapper",class:{'is-close': !_vm.layout.sidebarOpen}},[_c('sidebar',{attrs:{"menu":_vm.menu}}),_c('div',{staticClass:"adm-layout-main"},[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }